import { render, staticRenderFns } from "./FarmacieViewPage.vue?vue&type=template&id=7743e94e"
import script from "./FarmacieViewPage.vue?vue&type=script&lang=js"
export * from "./FarmacieViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports